import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormView } from '@form/cer-form-view';


export class BlobStorageForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(BlobStorageForm.viewGet());
  }

  public static viewGet() : CerFormView {
    var v = new CerFormView();
    v.viewMetadata = {
      dataApiName: 'BlobStorage', primaryKey: 'id', titleFields: ['name'], baseFields: ['id', 'history']
    };
    v.fieldMetadata = [
      { name: 'name', text: 'Navn', tooltipText: 'Navn', required: true, widthType: FieldWidthEnum.M },
      { name: 'type', text: 'Type', required: true, widthType: FieldWidthEnum.M, foreignKeyTableName: 'BlobStorageType' }
    ];
    return v;
  }
}
